import { ISelectValue } from './select.types';

export const mapToSelectOptions = <
  T extends Record<string, unknown>,
  K1 extends keyof T,
  K2 extends keyof T
>(
  array: Array<T>,
  labelKey: K1,
  valueKey: K2
): ISelectValue[] =>
  array.map((item) => ({
    label: String(item[labelKey]),
    value: String(item[valueKey]),
  }));
